// Light/dark theme for the viewer. Sources, strongest first:
//   1. the embedding page, via postMessage {type:'splat-tour:theme', theme} (embed.js watches the
//      agent's page for its own dark-mode switch and forwards changes live)
//   2. ?theme=light|dark in the iframe URL (initial value from embed.js)
//   3. the visitor's system setting (prefers-color-scheme), followed live
const VALID = ['light', 'dark', 'auto'];

export class Theme {
    constructor(initial = 'auto') {
        this.forced = VALID.includes(initial) ? initial : 'auto';
        this.listeners = [];
        this.mq = window.matchMedia('(prefers-color-scheme: dark)');
        this.mq.addEventListener?.('change', () => this._changed());
        window.addEventListener('message', (e) => {
            if (e.source !== window.parent || e.data?.type !== 'splat-tour:theme') return;
            this.set(e.data.theme);
        });
        this._apply();
    }

    /** Resolved theme: 'light' or 'dark'. */
    get value() {
        if (this.forced !== 'auto') return this.forced;
        return this.mq.matches ? 'dark' : 'light';
    }

    set(theme) {
        if (!VALID.includes(theme) || theme === this.forced) return;
        this.forced = theme;
        this._changed();
    }

    onChange(fn) {
        this.listeners.push(fn);
    }

    _apply() {
        const html = document.documentElement;
        if (this.forced === 'auto') delete html.dataset.theme;
        else html.dataset.theme = this.forced;
    }

    _changed() {
        this._apply();
        for (const fn of this.listeners) fn(this.value);
    }
}
